import React, { Component } from "react";
import styled from "styled-components";
import { Span, StyledText } from "../common/basic";
import { format } from 'date-fns'
import {
  ProfileIcon,
} from "../svgs";

const Comment = ({ comment, msisdn, createdAt, profilePhoto }) => {
  const timeStamp = new Date(createdAt);
  const dateFormatted = format(timeStamp, 'Pp');
  return (
    <Comments>
      <ProfilePicContainer>
        {
          profilePhoto ? <img style={{ width: '30px', objectFit: 'cover', height: '30px', borderRadius: '15px' }} src={profilePhoto} /> :
            <DefaultAvatar><ProfileIcon width={16} height={16} /></DefaultAvatar>
        }
      </ProfilePicContainer>
      <MessageContainer>
        <MessageTextContainer>
          <StyledText
            size={14}
            style={{
              fontFamily: "MTNRegular",
              marginBlockStart: 0,
              marginBlockEnd: 0,
            }}
          >
            <Span
              size={14}
              style={{
                fontFamily: "MTNBold",
                marginBlockStart: 0,
                marginBlockEnd: 0,
              }}
            >
              {msisdn + " "}
            </Span>
            {comment}
          </StyledText>
        </MessageTextContainer>
        <StyledText
          size={10}
          style={{
            fontFamily: "MTNRegular",
            alignSelf: "start",
            marginBlockStart: 0,
            marginBlockEnd: 0,
            marginTop: 3,
            color: '#777',
          }}
        >
          {dateFormatted}
        </StyledText>
      </MessageContainer>
    </Comments>
  );
};

const Comments = styled.div`
  display: flex;
  /* width: 100%; */
  margin: 5px;
`;

const ProfilePicContainer = styled.div`
  /* width: 30px; */
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
`;

const DefaultAvatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-grow: 1;
  margin: 5px;
  flex-direction: column;
`;

const MessageTextContainer = styled.div`
  border-width: 1px;
  background-color: #fee5f0;
  border-radius: 10px;
  padding: 5px;
  padding: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  &::after {
  }
`;

export default Comment;
